import { OrderOptimizerListItemRoute } from "../../../../../common/services/order-optimizer/list/order-optimizer-list";
import OrderOptimizerRoadRouteParams, {
  OrderOptimizerRoadRouteParamsWaypoints,
} from "../../../../../common/services/order-optimizer/road-route/order-optimizer-road-route-params";
import {
  OrderOptimizerRailyListingItemRoute,
  OrderOptimizerRailyListingItem,
} from "./types/order-optimizer-raily-listing-item";

const createWaypoint = (
  address: OrderOptimizerListItemRoute,
): OrderOptimizerRailyListingItemRoute => {
  return {
    lat: address.lat,
    lon: address.lon,
    orderHumanId: address.orderHumanId,
  };
};

const createWaypoints = (
  responseTransportingOrderOptimizations: OrderOptimizerRailyListingItem,
): OrderOptimizerRailyListingItemRoute[][] => {
  const splitWaypoints: OrderOptimizerListItemRoute[][] = [];

  responseTransportingOrderOptimizations.orders.forEach((order) => {
    splitWaypoints.push(
      responseTransportingOrderOptimizations.route.filter(
        (point) => point.orderHumanId === order.humanId,
      ),
    );
  });

  return splitWaypoints.map((route) => route.map(createWaypoint));
};

const createSearchRoutingCoordinate = (
  waypoint: OrderOptimizerRailyListingItemRoute,
): OrderOptimizerRoadRouteParamsWaypoints => {
  return {
    lat: waypoint.lat,
    lon: waypoint.lon,
  };
};

const createSearchRoutingRequest = (
  waypoints: OrderOptimizerRailyListingItemRoute[],
): OrderOptimizerRoadRouteParams => {
  const request: OrderOptimizerRoadRouteParams = {
    waypoints: waypoints.map(createSearchRoutingCoordinate),
  };

  return request;
};

const orderOptimizerRailyDetailsWaypointFactory = {
  createWaypoints,
  createSearchRoutingRequest,
};

export default orderOptimizerRailyDetailsWaypointFactory;
